/**
 * Extract Google Sheet id from share URL.
 * e.g. https://docs.google.com/spreadsheets/d/SHEET_ID/edit -> SHEET_ID
 */
export function extractSheetIdFromUrl(urlOrId: string): string {
  const match = urlOrId.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
  const id = match?.[1];
  if (id) return id;
  if (/^[a-zA-Z0-9-_]+$/.test(urlOrId)) return urlOrId;
  throw new Error('Invalid sheet URL or id');
}
